import { images } from "../constants";

const gallery = [
    {
        id: 1,
        image: images.gallery1,
        title: 'Opening Ceremony',
    },
    {
        id: 2,
        image: images.gallery2,
        title: 'Keynote Sessions',
    },
    {
        id: 3,
        image: images.gallery3,
        title: 'Networking Moments',
    },
    {
        id: 4,
        image: images.gallery4,
        title: 'Panel Discussions',
    },
    {
        id: 5,
        image: images.gallery5,
        title: 'Live Demos',
    },
    {
        id: 6,
        image: images.gallery6,
        title: 'Q&A Sessions',
    },
    {
        id: 7,
        image: images.gallery7,
        title: 'Attendee Engagement',
    },
    {
        id: 8,
        image: images.gallery8,
        title: 'Venue Highlights',
    },
    {
        id: 9,
        image: images.gallery9,
        title: 'Closing Remarks',
    },
];

export default gallery;